import { createActionTypeModel } from "../../../../store/global/action-model";

export const SharingData = createActionTypeModel('SharingData');

export const RssData =createActionTypeModel('RssData')



